export enum ConnectionLicenseType {
  Backup = 1,
  RMM = 2
}
